// Material
import { ListItem, ListItemButton, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  height: '50px',
  boxSizing: 'border-box',
  padding: '0 15px 0 20px',
  backgroundColor: theme.palette.white,
  color: theme.palette.secondary.main,
}))

export function ListItemTextButton({
  onClick,
  value,
}: {
  onClick: () => void
  value: string
}) {
  return (
    <ListItem disablePadding>
      <StyledListItemButton onClick={onClick}>
        <Typography color="secondary.main" variant="subtitle3">
          {value}
        </Typography>
      </StyledListItemButton>
    </ListItem>
  )
}
